import React, { useState } from 'react';
import AuthCode from 'react-auth-code-input';
import { Form, Icon, Input, Button, Layout, Switch, Checkbox } from "antd";
import i18next from "i18next";
import Countdown from 'react-countdown';

export default function MFA(props){

    const [result, setResult] = useState(0);
    const [isLoading, setLoading] = useState(false);
    const[fromTime,setFromTime]=useState(Date.now())

    const handleOnChange = (res) => {
      setResult(res);
    };

    // Simple function to handle OTP submission
    const submitOTP = async (e) => {
      if (e) e.preventDefault();
      if(result.length === 6 && !isLoading) {
        setLoading(true);
        await props.verifyMFA(result);
        setLoading(false);
      }
    };

    const Completionist = () => <span>Time's up!</span>;

    const renderer = ({ hours, minutes, seconds, completed }) => {
        if (completed) {
          // Render a completed state
          // console.log(api.isCompleted())
          return <Completionist />;
        } else {
          // Render a countdown
          return <span>{minutes}:{seconds}</span>;
        }
      };
      
      const maskNumber=(number)=> {
        const numStr = number.toString();
        
        if (numStr.length > 3) {
            return numStr.substring(0, numStr.length - 3).replace(/./g, '*') + numStr.substring(numStr.length - 3);
        } else {
            return numStr;
        }
    }
    return(
         <>
         <Form onSubmit={submitOTP} className="title">   
            <h3>OTP Verification</h3>
            <p className="info">{"An OTP has been sent to "+maskNumber(props.userNumber)}</p>
            <p className="msg">Please enter OTP to verify</p>
            <Countdown
              date={fromTime + 300000}
              renderer={renderer}
              // autoStart={false}
            />
            <div className="otp-input-field">
                <AuthCode 
                  containerClassName='container' 
                  inputClassName='input' 
                  allowedCharacters='numeric' 
                  onChange={handleOnChange}
                  inputMode="numeric"
                />
            </div>
            <Form.Item>
                <Button
                    type="primary"
                    htmlType="submit"
                    // style={{marginLeft:100}}
                    disabled={result.length !=6 || isLoading }
                    loading={isLoading}
                >
                    {i18next.t("Submit")}
                </Button>
                <Button
                    type="primary"
                    style={{marginLeft:10}}
                    onClick={()=>{
                      props.verifyMFA(null)
                    }}
                >
                    {i18next.t("Back")}
                </Button>
            </Form.Item>
         </Form>
         </>
    );
}
